import { render, staticRenderFns } from "./ticket-item.vue?vue&type=template&id=6ec7c57d"
import script from "./ticket-item.vue?vue&type=script&lang=js"
export * from "./ticket-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports